import { useEffect } from 'react';
import PricingTable from '../components/PricingTable';
import FAQ from '../components/FAQ';
import CTA from '../components/CTA';

export default function Pricing() {
  useEffect(() => window.scrollTo(0, 0), []);
  return (
    <>
      <section className="section-fade pt-16 pb-4">
        <div className="max-w-4xl mx-auto text-center px-5 lg:px-8">
          <p className="chip mb-4">Pricing</p>
          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight text-slate-900">
            Simple, transparent pricing
          </h1>
          <p className="mt-5 text-slate-600 text-lg">
            Start free. Upgrade when you grow. Cancel anytime.
          </p>
        </div>
      </section>
      <PricingTable />
      <FAQ />
      <CTA />
    </>
  );
}
